module.exports = __webpack_public_path__ + "media/images/sb-loading-c4759c9d.svg";